var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0795 3.33046L5.90906 7.49999H1.125C0.503438 7.49999 0 8.00343 0 8.62499V15.375C0 15.9961 0.503438 16.5 1.125 16.5H5.90906L10.0795 20.6695C10.7841 21.3741 12 20.8791 12 19.8741V4.12593C12 3.11999 10.7831 2.62686 10.0795 3.33046ZM21.6394 12L23.7787 9.86061C24.0741 9.5653 24.0741 9.08624 23.7787 8.79093L22.7091 7.72124C22.4137 7.42593 21.9347 7.42593 21.6394 7.72124L19.5 9.86061L17.3606 7.72124C17.0653 7.42593 16.5863 7.42593 16.2909 7.72124L15.2213 8.79093C14.9259 9.08624 14.9259 9.5653 15.2213 9.86061L17.3606 12L15.2217 14.1389C14.9264 14.4342 14.9264 14.9133 15.2217 15.2086L16.2914 16.2783C16.5867 16.5736 17.0658 16.5736 17.3611 16.2783L19.5 14.1394L21.6394 16.2787C21.9347 16.5741 22.4137 16.5741 22.7091 16.2787L23.7787 15.2091C24.0741 14.9137 24.0741 14.4347 23.7787 14.1394L21.6394 12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.9a8ac9dc55d0dc8a51a979df3ee40e67.svg";
export { ForwardRef as ReactComponent };